import React from 'react';
import AppRouter from './components/Router';
import TranslationProvider from './Providers/TranslationProvider';
import './App.less';
import './Cls.less';

const App = () => (
    <TranslationProvider>
        <div className="loans-simulator-app" id="loans-simulator">
            <AppRouter/>
        </div>
    </TranslationProvider>
);

export default App;
